import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEO({ title, description, keywords, canonicalUrl, ogType, ogImage, schema }: SEOProps) {
  const fullTitle = `${title} | ASMR导航 — 最全ASMR资源导航`;
  const baseUrl = 'https://asmr-navigation.com';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonicalEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonicalEl) {
      canonicalEl.setAttribute('href', `${baseUrl}${canonicalUrl}`);
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `${baseUrl}${canonicalUrl}`;
      document.head.appendChild(link);
    }

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType || 'website', true);
    setMeta('og:url', `${baseUrl}${canonicalUrl}`, true);
    setMeta('og:site_name', 'ASMR导航', true);
    setMeta('og:locale', 'zh_CN', true);
    if (ogImage) setMeta('og:image', ogImage, true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    if (ogImage) setMeta('twitter:image', ogImage);

    if (schema) {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) existingScript.remove();
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schema, fullTitle, baseUrl]);

  return null;
}